import { TMPL_RECON_LISTENER_EVENT } from '@amzn/aws-marketing-experience-builder-template-types';
import { isServer } from '../environment/is-server';
export const createReconEvent = (detail) => {
    if (isServer()) {
        return {
            send: () => { },
        };
    }
    const send = () => {
        document.dispatchEvent(new CustomEvent(TMPL_RECON_LISTENER_EVENT, {
            detail,
        }));
    };
    return { send };
};
